/** @format */

import React from 'react';

import TableViewIcon from '@mui/icons-material/TableView';

import {useNavigate} from 'react-router-dom';

import {useMixpanelContext} from 'contexts/MixpanelContext';
import {useCompanyContext} from 'contexts/CompanyContext';

import {ActionButton, ActionsCell} from './styles';

interface Props {
  reportId: string;
  onReportView?: (reportId: string) => void;
}

const ActionsMenu = ({reportId, onReportView}: Props) => {
  const {currentCompany} = useCompanyContext();
  const {mixpanel} = useMixpanelContext();
  const navigate = useNavigate();

  const handleOpen = () => {
    mixpanel.track('ai_report_click_open_table', {
      project_uuid: currentCompany?.uuid,
      marvin_id: reportId,
      order_id: reportId,
    });

    onReportView?.(reportId);

    navigate(`/home/ai-reports/${currentCompany.id}/${reportId}`);
  };

  return (
    <ActionsCell>
      <ActionButton
        variant='outlined'
        size='small'
        onClick={handleOpen}
        startIcon={<TableViewIcon />}
      >
        Таблицей
      </ActionButton>
    </ActionsCell>
  );
};

export default ActionsMenu;
